export default __webpack_public_path__ + "a813b9356534417288bc59e776770b1e.png";